import { render, staticRenderFns } from "./ProviderBookElementsRevModal.vue?vue&type=template&id=e9cde82c&scoped=true&"
import script from "./ProviderBookElementsRevModal.vue?vue&type=script&lang=js&"
export * from "./ProviderBookElementsRevModal.vue?vue&type=script&lang=js&"
import style0 from "./ProviderBookElementsRevModal.vue?vue&type=style&index=0&id=e9cde82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cde82c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDataTable,VSpacer})
